import {global} from "../../appContext";

export namespace nsResetPassword {

    export function get_changepasswordrequiresoldpassword(): boolean {
        const user = global.login.user();
        if (!user) {
            return true;
        }
        const a = user.authenticationtype != 8;
        const b = global.login.selectedOrganization()?.changepasswordrequiresoldpassword ?? true;
        return a && b
    }
}